<div class="my-3 my-md-5">
    <div class="container-fluid">
        <h1 class="page-title">Member Lead's</h1>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-3 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Circle" [(ngModel)]="circle" multiple>
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Catergory" [(ngModel)]="lead_category_filter" multiple>
                                <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Source"  [(ngModel)]="lead_source" multiple>
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of alltreatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Test Category" [(ngModel)]="lab_category_filter" multiple>
                              <mat-option value="{{cat_f.id}}" *ngFor="let cat_f of lab_category">{{cat_f.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <button type="button" class="btn btn-primary mb-4" (click)="loadmembersLeads(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                        </div>

                    </div>
                    
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadmembersLeads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                    <button type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportMemberLeadData()"><i class="fa fa-file-excel"></i> Export List</button>
                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <!-- <th>Mobile</th> -->
                        <th>Lead Type</th>
                        <th>Source</th>
                        <th>Treatment</th>
                        <th>Treatment Catergory</th>
                        <th>Package</th>
                        <th>City Name</th>
                        <th>Circle Name</th>
                        <th>Test Catergory</th>
                        <th>Test Sub-Catergory</th>
                        <th>Date</th>
                        
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let leads of memberList;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>{{leads.lead_name}}</td>
                        <!-- <td>{{leads.mobile}}</td> -->
                        <td>
                            <span *ngIf="leads.lead_type==1 && leads.treatment_category_id!=11">Surgery Lead</span>
                            <span *ngIf="leads.lead_type==2">Lab Lead</span>
                            <span *ngIf="leads.lead_type==3">Retail Lead</span>
                            <span *ngIf="leads.lead_type==4">Corporate Lead</span>
                            <span *ngIf="leads.lead_type==1 && leads.treatment_category_id==11">GP Lead</span>
                        </td>
                        <td>{{leads.source_name}}</td>
                        <td>{{leads.treatment_name}}</td>
                        <td>{{leads.catergory_name}}</td>
                        <td>{{leads.plan_name}}</td>
                        <td>{{leads.city_name}}</td>
                        <td>{{leads.circle_name}}</td>
                        <td>{{leads.category_test_name}}</td>
                        <td>{{leads.test_name}}</td>
                        <td> {{leads.created_at*1000 | date: 'dd/MM/yyyy'}}</td>
                       
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="11" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !memberList.length">
                        <td colspan="11" ><i class="far fa-frown"></i> No member lead found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>